import { SimpleTextParagraph } from 'app/src/shared/components'
import { useTranslation } from 'react-i18next'

export function InformativeSection() {
  const { t } = useTranslation('tutorial', { keyPrefix: 'Tutorial.InformativeSection' })
  return <SimpleTextParagraph txt={t('Text')} />
}
